





















import { defineComponent, type PropType } from "vue-demi";
import type { PageData } from "@constructor/shared-entity/type";
import type { UserCart } from "../../../type/UserCart";
import type { SectionMeta } from "../../../type/SectionMeta";

// компоненты стора
import GGDefaultSection from "../GGDefaultSection.vue";
import GGSaleSection from "../GGSaleSection.vue";
import GGReviewSection from "../GGReviewSection.vue";
import GGDarkstoreSection from "../GGDarkstoreSection.vue";
import GGPhoneSection from "../GGPhoneSection/GGPhoneSection.vue";
import GGBanner from "../GGBanner/GGBanner.vue";
import GGSaleItems from "../GGSaleItems/GGSaleItems.vue";
import GGFlash from "../GGFlash/GGFlash.vue";
import GGSaleGrid from "../GGSaleGrid.vue";
import GGScrollBar from "../GGScrollBar/GGScrollBar.vue";
import GGStoryBar from "../GGStoryBar/GGStoryBar.vue";

// компоненты маркетплейса
import MPHero from "../marketplace/MPHero/MPHero.vue";
import MPShopsMap from "../marketplace/MPShopsMap/MPShopsMap.vue";
import MPCategoryGrid from "../marketplace/MPCategoryGrid.vue";
import MPServices from "../marketplace/MPServices/MPServices.vue";
import MPShopsSlider from "../marketplace/MPShopsSlider/MPShopsSlider.vue";
import MPProductsSlider from "../marketplace/MPProductsSlider.vue";
import getValueForProp from "../../../helper/getValueForProp";

export default defineComponent({
  name: "GGSection",
  components: {
    GGDefaultSection,
    GGSaleSection,
    GGReviewSection,
    GGDarkstoreSection,
    GGPhoneSection,
    GGBanner,
    GGSaleItems,
    GGFlash,
    GGSaleGrid,
    GGScrollBar,
    GGStoryBar,
    MPHero,
    MPShopsMap,
    MPCategoryGrid,
    MPServices,
    MPShopsSlider,
    MPProductsSlider,
  },
  props: {
    project: {
      type: String as PropType<string>,
      default: "default",
    },
    data: {
      type: Object as PropType<PageData>,
      required: true,
    },
    userCart: {
      type: Object as PropType<UserCart>,
      default: () => ({}),
    },
    meta: {
      type: Object as PropType<SectionMeta>,
      default: () => ({}),
    },
    preview: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  emits: {
    "cart-add": (_: number) => true,
    "cart-remove": (_: number) => true,
    "auth-needed": () => true,
  },
  computed: {
    disable() {
      if (this.preview) return false;

      const date =
        getValueForProp("enableFromDate", this.data.template.prop) || undefined;
      if (!date) return false;

      return new Date(date) > new Date();
    },
  },
});
